export default "__VITE_ASSET__DqAAx0oq__"